import { MinusIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Minus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <MinusIcon color={stroke || fill} size={Sizes[size]} {...rest} />;
};

Minus.displayName = 'Minus';
